import { render, staticRenderFns } from "./CategorySubCommoditySpecSlider.vue?vue&type=template&id=3dd2f7c6&"
import script from "./CategorySubCommoditySpecSlider.vue?vue&type=script&lang=js&"
export * from "./CategorySubCommoditySpecSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports